import React from 'react'
import './Companysec.css'
import img from '../../assets/others/11102066.png'


const Companysec = () => {
  return (
    <section className='Companysec'>
           <div class="container text-center p-lg-5">
                         <div class="row justify-content-around text-center">
                              <div class="col-md p-3">
                                    <h2 className='ws-section_heading pd-03'><span className='font-thi'>Your Future Success Lies with Your Dream Employer
                                    </span></h2>
                              </div>
                          </div>
                          <div class="row justify-content-around">
                              <div class="col-md-10">
                              <img src={img} alt=''/>
                              </div>
                          </div>
                </div>
    </section>
  )
}

export default Companysec